<div class="dash">
    <div class="row">
        <div class="col-12 ml-auto mr-auto">
            <div class="dash-card no-padding">
                <div
                    class=" dash-card-header d-flex align-items-start justify-content-between">
                    <h2>Documentos</h2>

                    <app-button (onClick)="formToggle(true)" class="add-button"
                        *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2 mb-1"></svg-icon>
                        Adicionar documento
                    </app-button>
                </div>

                <div class="dash-card-body  padding-container"
                    style="overflow: visible;">
                    <div clsas="styled-scroll">
                        <ng-container *ngIf="loading">
                            <table #table class="bordered">
                                <tbody>
                                    <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                        <td>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '200px',
                                                marginBottom:'0'
                                              }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td class="item-number">
                                            <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '40px',
                                            marginBottom:'0',
                                            marginLeft: 'auto'
                                          }">
                                            </ngx-skeleton-loader>
                                        </td>
                                        <td>
                                            <div
                                                style="display: flex; gap: 8px; justify-content: flex-end;">
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '16px',
                                                    width: '16px',
                                                    marginBottom:'0',
                                                    borderRadius: '0'
                                                  }">
                                                </ngx-skeleton-loader>
                                                <ngx-skeleton-loader [theme]="{
                                                    height: '16px',
                                                    width: '16px',
                                                    marginBottom:'0',
                                                    borderRadius: '0'
                                                  }">
                                                </ngx-skeleton-loader>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </ng-container>

                        <table class="bordered" *ngIf="!loading">
                            <thead>
                                <tr>
                                    <th>Documento</th>
                                    <th>Qtde. de Vínculos</th>
                                    <th></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr *ngFor="let document of documents">
                                    <td class="">
                                        <div class="d-flex flex-column">
                                            <span
                                                class="documents-name">{{document.name}}</span>
                                            <span
                                                class="documents-description">{{document.description}}</span>
                                        </div>
                                    </td>
                                    <td>{{formatRoles(document.roles)}}</td>
                                    <td>
                                        <div class="dash-card-item-buttons">
                                            <app-tooltip text="Editar"
                                                *ngIf="permissionObj.canChange">
                                                <button class="dash-item-button"
                                                    (click)="setDocument(document)">
                                                    <svg-icon
                                                        src="assets/images/icon-edit.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                            <app-spacer
                                                [right]="16"></app-spacer>

                                            <app-tooltip text="Excluir"
                                                *ngIf="permissionObj.canRemove">
                                                <button class="dash-item-button"
                                                    (click)="openDeleteModal(document)">
                                                    <svg-icon
                                                        src="assets/images/icon-trash.svg"></svg-icon>
                                                </button>
                                            </app-tooltip>
                                        </div>
                                    </td>
                                </tr>

                                <tr *ngIf="documents.length === 0">
                                    <td>Nenhum documento adicionado</td>
                                </tr>

                            </tbody>
                            <app-spacer [bottom]="28"></app-spacer>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-side-modal [active]="modal" (onClose)="closeModal()"
    [title]="document ? 'Atualizar documento' : 'Adicionar documento'"
    paddingBottom="30">
    <ng-container *ngIf="modal">
        <div class="row align-items-center" [formGroup]="form">
            <div class="col-12">
                <app-input label="Nome do documento" [group]="form"
                    controlName="name" helpText="Máximo de 100 caracteres"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-input label="Descrição" [rows]="3" [group]="form"
                    controlName="description"
                    helpText="Máximo de 900 caracteres" [maxLength]="900">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="agentsOptions" [multiple]="true"
                    label="Defina para quais agentes este documento deve ser solicitado"
                    [group]="form" controlName="roles">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12" *ngIf="showFrameworks">
                <div style="margin-bottom: 12px;">
                    <app-radio [multiple]="true"
                        [isChecked]="allFrameworksSelected"
                        (onCheckChanged)="toggleAllFrameworks($event)">
                        <span class="app-radio-text">Todos os
                            enquadramentos</span>
                    </app-radio>
                </div>
                <app-select [items]="frameworkList" [multiple]="true"
                    label="Defina o enquadramento da empresa" [group]="form"
                    controlName="frameworks"
                    [readOnly]="disableFrameworksSelect"
                    [disabled]="disableFrameworksSelect">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="required">
                    <span class="app-radio-text">Preenchimento
                        obrigatório</span>
                </app-radio>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="have_due_date">
                    <span class="app-radio-text">Possui data de validade</span>
                </app-radio>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="individual"
                    [disabled]="disableIndividual">
                    <span class="app-radio-text">Solicitar individualmente para
                        cada pessoa física</span>
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div>
        </div>

        <div class="row button-sticky">
            <div class="col-12">
                <div class="d-flex justify-content-between gap-2">
                    <app-button (onClick)="closeModal()" [phantom]="true">
                        Cancelar
                    </app-button>
                    <app-button (onClick)="addDocument()"
                        [disabled]="form.invalid" [loading]="savingDocument"
                        class="add-button">
                        Concluir
                    </app-button>
                </div>
            </div>
        </div>
    </ng-container>

</app-side-modal>

<!-- Carbon Warning Modals -->
<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteDocument.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<!-- Loading Spinner -->
<app-loading-spinner [active]="deletingDocument"></app-loading-spinner>

<app-carbon-warning-modal [active]="showSuccessModal"
    [title]="getSuccessModalTitle()" [message]="getSuccessModalMessage()"
    [confirmText]="getSuccessConfirmText()" [cancelText]="''"
    [confirmAction]="closeSuccessModal.bind(this)"
    [cancelAction]="closeSuccessModal.bind(this)"
    (onClose)="closeSuccessModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showErrorModal"
    [title]="getErrorModalTitle()" [message]="getErrorModalMessage()"
    [confirmText]="getErrorConfirmText()" [cancelText]="''"
    [confirmAction]="closeErrorModal.bind(this)"
    [cancelAction]="closeErrorModal.bind(this)" (onClose)="closeErrorModal()">
</app-carbon-warning-modal>